import Debug from 'debug';
import {BlHostStatusCode} from "./BlHostCommands";

const debug = Debug('blhost:error');

export const ErrorCode = {
    // Error message types
    ERROR_MESSAGE: 0x00,
    ERROR_MESSAGE_RSP: 0x01,
    ERROR_MESSAGE_EXT: 0x02,

    // Error code for BlHostAbstractTransport
    ERROR_CAN_NOT_INIT_ABSTRACT_TRANSPORT: 0x0000,
    ERROR_PRE_DFU_INTERRUPTED: 0x0001,
    ERROR_UNEXPECTED_BYTES: 0x0002,
    ERROR_CRC_MISMATCH: 0x0003,
    ERROR_TOO_MANY_WRITE_FAILURES: 0x0004,
    ERROR_INSUFFICIENT_BYTES: 0x0005,

    // Error code for BlHostTransportPrn
    ERROR_CAN_NOT_INIT_PRN_TRANSPORT: 0x0010,
    ERROR_CAN_NOT_USE_HIGHER_PRN: 0x0011,
    ERROR_READ_CONFLICT: 0x0012,
    ERROR_TIMEOUT_READING_SERIAL: 0x0013,
    ERROR_RECEIVE_TWO_MESSAGES: 0x0014,
    ERROR_RESPONSE_NOT_START_WITH_0x60: 0x0015,
    ERROR_ASSERT_EMPTY_RESPONSE: 0x0016,
    ERROR_UNEXPECTED_RESPONSE_COMMANDTAG: 0x0017,
    ERROR_UNEXPECTED_RESPONSE_BYTES: 0x0018,

    // Error code for response error messages
    ERROR_RSP_INVALID: 0x0100,
    ERROR_RSP_SUCCESS: 0x0101,
    ERROR_RSP_OP_CODE_NOT_SUPPORTED: 0x0102,
    ERROR_RSP_INVALID_PARAMETER: 0x0103,
    ERROR_RSP_INSUFFICIENT_RESOURCES: 0x0104,
    ERROR_RSP_INVALID_OBJECT: 0x0105,
    ERROR_RSP_UNSUPPORTED_TYPE: 0x0107,
    ERROR_RSP_OPERATION_NOT_PERMITTED: 0x0108,
    ERROR_RSP_OPERATION_FAILED: 0x010A,
    ERROR_RSP_EXT_ERROR: 0x010B,
};

// Error types for errorMessages, responseErrorMessages and extendedErrorMessages
export const ErrorTypes = {
    [ErrorCode.ERROR_MESSAGE]: 'Error message',
    [ErrorCode.ERROR_MESSAGE_RSP]: 'Error message for known response code from BlHost target',
    [ErrorCode.ERROR_MESSAGE_EXT]: 'Error message for known extended error code from BlHost target',
};

// Error messages for blhost-js
export const ErrorMessages = {
    [ErrorCode.ERROR_CAN_NOT_INIT_ABSTRACT_TRANSPORT]: 'Cannot instantiate BlHostAbstractTransport, use a concrete subclass instead.',
    [ErrorCode.ERROR_PRE_DFU_INTERRUPTED]: 'A previous DFU process was interrupted, and it was left in such a state that cannot be continued. Please perform a DFU procedure disabling continuation.',
    [ErrorCode.ERROR_UNEXPECTED_BYTES]: 'Unexpected bytes to be sent.',
    [ErrorCode.ERROR_CRC_MISMATCH]: 'CRC mismatches.',
    [ErrorCode.ERROR_TOO_MANY_WRITE_FAILURES]: 'Too many write failures.',
    [ErrorCode.ERROR_CAN_NOT_INIT_PRN_TRANSPORT]: 'Cannot instantiate BlHostTransportPrn, use a concrete subclass instead.',
    [ErrorCode.ERROR_CAN_NOT_USE_HIGHER_PRN]: 'BlHost procotol cannot use a PRN higher than 0xFFFF.',
    [ErrorCode.ERROR_READ_CONFLICT]: 'BlHost transport tried to read() while another read() was still waiting',
    [ErrorCode.ERROR_TIMEOUT_READING_SERIAL]: 'Timeout while reading from serial transport. No bytes received?',
    [ErrorCode.ERROR_RECEIVE_TWO_MESSAGES]: 'BlHost transport received two messages at once',
    [ErrorCode.ERROR_RESPONSE_NOT_START_WITH_0x60]: 'Response from BlHost target did not start with 0x60',
    [ErrorCode.ERROR_ASSERT_EMPTY_RESPONSE]: 'Tried to assert an empty parsed response',
    [ErrorCode.ERROR_UNEXPECTED_RESPONSE_COMMANDTAG]: 'Unexpected commandTag in response',
    [ErrorCode.ERROR_UNEXPECTED_RESPONSE_BYTES]: 'Unexpected bytes in response',
    // [ErrorCode.ERROR_MUST_HAVE_PAYLOAD]: 'Must create/select a payload type first.',
    // [ErrorCode.ERROR_INVOKED_MISMATCHED_CRC32]: 'Invoked with a mismatched CRC32 checksum.',
    // [ErrorCode.ERROR_MORE_BYTES_THAN_CHUNK_SIZE]: 'Tried to push more bytes to a chunk than the chunk size.',
    // [ErrorCode.ERROR_INVALID_PAYLOAD_TYPE]: 'Tried to select invalid payload type. Valid types are 0x01 and 0x02.',
    // [ErrorCode.ERROR_CAN_NOT_SUBSCRIBE_CHANGES]: 'Could not subscribe to changes of the control characteristics',
    // [ErrorCode.ERROR_UNKNOWN_FIRMWARE_TYPE]: 'Unknown firmware image type',
    // [ErrorCode.ERROR_UNABLE_FIND_PORT]: 'Unable to find port.',
};

// Error messages for the known response codes.

export const ResponseErrorMessages = {
    [ErrorCode.ERROR_RSP_INVALID]: 'Missing or malformed commandTag.',
    //  0x01: success
    [ErrorCode.ERROR_RSP_OP_CODE_NOT_SUPPORTED]: 'commandTag unknown or not supported.',
    [ErrorCode.ERROR_RSP_INVALID_PARAMETER]: 'A parameter for the commandTag was missing.',
    [ErrorCode.ERROR_RSP_INSUFFICIENT_RESOURCES]: 'Not enough memory for the data object.',
    // 0x05 should not happen. Bootloaders starting from late 2017 and later will
    // use extended error codes instead.
    [ErrorCode.ERROR_RSP_INVALID_OBJECT]: 'The data object didn\'t match firmware/hardware, or missing crypto signature, or malformed protocol buffer, or command parse failed.',
    //  0x06: missing from the spec
    [ErrorCode.ERROR_RSP_UNSUPPORTED_TYPE]: 'Unsupported object type for create/read operation.',
    [ErrorCode.ERROR_RSP_OPERATION_NOT_PERMITTED]: 'Cannot allow this operation in the current BlHost state.',
    //  0x09: missing from the spec
    [ErrorCode.ERROR_RSP_OPERATION_FAILED]: 'Operation failed.',
//  0x0B: extended error, will read next byte from the response and use it as extended error code
};

/**
 * Error class for BlHost
 */
export class BlHostError extends Error {
    constructor(code, message = undefined) {
        super();
        this.code = code;
        this.message = BlHostError.getErrorMessage(code);
        if (message) {
            this.message += ` ${message}`;
        }
    }

    static getErrorMessage(code) {
        let errorMsg;

        const keys = Object.keys(BlHostStatusCode);
        const key = keys.find(k => BlHostStatusCode[k] == code);

        debug(`Error ${code}: ${key}.`);

        errorMsg = ErrorMessages[code];
        if (!errorMsg) {
            return key;
        }

        return errorMsg;
    }
}
